<template>
    <div>
        <h3 class="text-center mb-3">Agregar Docente</h3>

        <b-row class="my-3">
            <b-col cols="12">
                <b-button
                    variant="info"
                    class="mx-2"
                    :to="{ name: 'admin-professors-list' }"
                >
                    <b-icon-arrow-bar-left /> Atrás
                </b-button>
            </b-col>
        </b-row>

        <AdminProfessorsCreateSingle />

    </div>
</template>

<script>
import AdminProfessorsCreateSingle from './AdminProfessorsCreateSingle'

export default {
    name: 'AdminProfessorsCreate',
    components: {
        AdminProfessorsCreateSingle
    },
    data () {
        return { }
    }
}
</script>
